import { WidgetType } from '@anyonelab/frontend/src/models/Widget'

export const AVATAR_WIDGET_ID = 'AVATAR'

export const AvatarWidgetConfigDefaults: WidgetType['avatar'] = {
  imageUrl: '',
}
